'use strict';

exports.__esModule = true;
exports['default'] = childContext;

var _validators = require('../../utils/validators');

function childContext(obj) {
  return function (target) {
    (0, _validators.validateClass)(target, 'childContext');

    Object.defineProperty(target.prototype, 'getChildContext', {
      value: function childContextGetter() {
        return obj;
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/context/childContext.js
// module id = 561
// module chunks = 1